// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"19e2884a","338":"0d151144","477":"89a336c2","513":"0d151144","649":"0d151144","957":"e31e0900"}[chunkId] + ".chunk.css";
};